<template>
  <v-app>
    <v-snackbar v-model="snackbar" :color="color" multi-line="multi-line" :timeout="timeout" vertical="vertical" top>
      {{ text }}
    </v-snackbar>
    <v-app-bar
      app
      color="primary"
      dark
      v-if="$router.currentRoute.fullPath.indexOf('/estimate/') === -1 && $router.currentRoute.fullPath.indexOf('/booking/') === -1 && $router.currentRoute.fullPath.indexOf('/login') === -1"
    >
      <div class="d-flex align-center headline text-uppercase">
        <span>Repair Smart</span>
        <span class="font-weight-light ml-2 secondary--text">BOOKING SYSTEM</span>
      </div>

      <v-spacer/>

      <v-btn to="/" text>Home</v-btn>
      <v-btn to="/customers" text>Customers</v-btn>
      <v-btn to="/estimates" text>Estimates</v-btn>
      <v-btn to="/search" text>Search</v-btn>
      <v-btn to="/parts" text>Parts</v-btn>
      <v-btn to="/admin" text>Admin</v-btn>
      <v-btn @click="logout" text>Logout</v-btn>
    </v-app-bar>

    <v-content>
      <router-view />
    </v-content>
    <booking-dialog />
    <estimate-dialog />
    <manage-customer-dialog />
    <manage-note-dialog />
    <manage-event-dialog />
    <delete-booking-dialog />
    <delete-estimate-dialog />
    <delete-customer-dialog />
    <delete-part-dialog />
  </v-app>
</template>

<script>
import BookingDialog from "./components/modals/booking/BookingDialog";
import DeleteBookingDialog from "./components/modals/booking/DeleteBookingDialog"
import {EventBus} from "./EventBus.js";
import EstimateDialog from "./components/modals/estimate/EstimateDialog";
import DeleteEstimateDialog from "./components/modals/estimate/DeleteEstimateDialog";
import ManageCustomerDialog from "./components/modals/customers/ManageCustomerDialog";
import ManageNoteDialog from "./components/modals/admin/ManageNoteDialog";
import ManageEventDialog from "./components/modals/admin/ManageEventDialog";
import DeleteCustomerDialog from "./components/modals/customers/ManageDeleteCustomerDialog";
import DeletePartDialog from "./components/modals/parts/DeletePartDialog";
export default {
  name: 'App',
  components: {
    DeletePartDialog,
    DeleteCustomerDialog,
    ManageEventDialog,
    ManageNoteDialog,
    ManageCustomerDialog, DeleteEstimateDialog, EstimateDialog, BookingDialog, DeleteBookingDialog},
  data: () => ({
    snackbar: false,
    color: '',
    timeout: 2000,
    text: ''
  }),
  methods: {
      logout() {
        EventBus.$emit('logout');
      }
  },
  mounted() {
    EventBus.$on('message', (data) => {
      this.snackbar = true;
      this.color = data.type;
      this.text = data.message;
      if (data.type === 'error') {
        this.timeout = 6000;
      }
    });

    EventBus.$on('logout', async() => {
      await this.$store.dispatch('app/setAuthStatus', false);
      await this.$store.dispatch('app/setToken', '');
      await this.$router.replace('/login');
    });
  }
};
</script>

<style>
  @font-face {
    font-family: CharlesWright;
    src: url('assets/fonts/CharlesWright-Bold.ttf');
  }

  .vrm {
    background-color: #F5C445 !important;
    color: black !important;
    font-family: CharlesWright,sans-serif !important;
    padding: 5px !important;
  }
</style>
